<template>
  <div class="groupsPrdtListing">
    <section class="detail_content">
      <p class="winner-message">{{$t('winnerMessage')}}</p>

      <ul class="winner-list">
        <div class="winner-product won" v-if="winningItem">
          <img src="../../assets/images/detail/crowns.svg" class="winner-logo" />
          <span class="won-text">You won</span>
          <span class="user-img">
            <img :src="winningItem.userImage" v-if="winningItem.userImage" alt />
            <img src="../../assets/images/dummy.png" v-else />
          </span>
          <h3>{{$t('userWonThisProduct')}}</h3>
          <h4>{{winningItem.itemName}}</h4>
          <span class="prod-img">
            <img :src="winningItem.itemImage" alt />
          </span>
          <button
            type="button"
            class="complete-order"
            @click="buyWinninItem(winningItem.preOrderId)"
          >{{$t('completeOrder')}}</button>
        </div>
        <li v-for="(winner , index) in availableWinnersList" :key="index" class="winner-product">
          <img src="../../assets/images/detail/crowns.svg" class="winner-logo" />
          <span class="user-img">
            <img :src="winner.userImage" v-if="winner.userImage" alt />
            <img src="../../assets/images/dummy.png" v-else />
          </span>
          <h3
            v-if="winner.location"
          >{{$t('userWonFromThis', {winnerName: winner.userName, winnerLocation: winner.location})}}</h3>
          <h3 v-else>{{$t('userWonThis', {winnerName: winner.userName})}}</h3>
          <h4>{{winner.itemName}}</h4>
          <span class="prod-img">
            <img :src="winner.itemImage" alt />
          </span>
        </li>
      </ul>
      <NoDataFound
        v-if="noData == true && this.availableWinnersList && this.availableWinnersList == 0"
        class="no_record"
      />
      <infinite-loading
        @infinite="cutPriceAvailProducts"
        spinner="circles"
        :class="{'visibilityHidden': noData == true}"
      >
        <template slot="no-results">{{$t('noMoreRecord')}}</template>
      </infinite-loading>
      <div class="loader" v-if="loading">
        <img src="../../assets/images/loader.gif" alt="loader" />
      </div>
    </section>
  </div>
</template>

<script>
import NoDataFound from "../../components/Common/NoDataFound";
import ApiCaller from "../../utils/apicaller";
import constant from "../../utils/constant";
export default {
  name: "LuckyWinnerList",
  components: {
    NoDataFound
  },
  data() {
    return {
      availableWinnersList: [],
      availableUsersIndex: 0,
      loading: false,
      noData: false,
      limit: 20,
      winningItem: {},
      winningItem: false
    };
  },
  methods: {
    getWinningItemdetail() {
      // this.loading = true;
      ApiCaller(constant.GAMING_API_URL, "user-pending-winning-items", "get")
        .then(data => {
          if (data.data.userPendingWinningItemDTOs[0]) {
            this.winningItem = true;
          }

          this.loading = false;
          this.winningItem = data.data.userPendingWinningItemDTOs[0];
        })
        .catch(err => {
          console.log(err);
        });
    },
    buyWinninItem(itemId) {
      this.$router.push("/preOrderDetails/" + itemId);
    },
    cutPriceAvailProducts($state) {
      this.loading = true;
      ApiCaller(
        constant.GAMING_API_URL,
        "winner/user/" + this.limit + "/" + this.availableUsersIndex,
        "get"
      )
        .then(data => {
          this.loading = false;

          if (data.data.winnerUserDTOs.length) {
            this.availableWinnersList.push(...data.data.winnerUserDTOs);

            this.availableUsersIndex += 1;
            $state && $state.loaded();
          } else {
            this.noData = true;
            $state && $state.complete();
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    // this.loading = true;
    this.getWinningItemdetail();
  }
};
</script>
<style scoped lang="scss">
.visibilityHidden {
  visibility: hidden;
}
.winner-message {
  color: #505050;
  font-size: 0.875em;
  font-family: "Hind", sans-serif;
  padding: 15px;
}
.winner-list {
  font-family: "Hind", sans-serif;
  padding: 35px 15px;
  background: #f4f6f8;
  // height: calc(100vh - 138px);

  .winner-product {
    padding: 15px 55px;
    position: relative;
    text-align: center;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0px 6px 0 rgba(0, 0, 0, 0.16);
    margin-bottom: 24px;
    &.won {
      margin-bottom: 50px;
      background: rgb(2, 120, 255);
      .won-text {
        background: #fdbf00;
        padding: 0 35px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: -28px;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
        font-weight: 600;
        text-transform: uppercase;
        font-family: "Roboto", sans-serif;
        line-height: 2;
        font-size: 0.875em;
      }
      h3,
      h4 {
        color: #fff;
      }
      .complete-order {
        position: absolute;
        bottom: -30px;
        right: 0;
        border: 0;
        background: none;
        color: #0278ff;
        font-weight: 600;
        font-size: 0.875em;
        text-shadow: 0px 0px 1px #0278ff;
        font-family: "Roboto", sans-serif;
      }
    }
    .winner-logo {
      position: absolute;
      top: -15px;
      left: 0;
    }
    .user-img {
      position: absolute;
      left: 10px;
      width: 42px;
      height: 42px;
      border-radius: 50%;
      overflow: hidden;
      top: 50%;
      transform: translateY(-50%);
      border: 1px solid #ddd;
      padding: 2px;
      background: #fff;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    .prod-img {
      position: absolute;
      right: 10px;
      width: 42px;
      height: 42px;
      border-radius: 50%;
      overflow: hidden;
      top: 50%;
      transform: translateY(-50%);
      border: 1px solid #ddd;
      padding: 2px;
      background: #fff;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
    h3 {
      color: #1d3433;
      font-weight: normal;
      font-size: 1.05em;
    }
    h4 {
      color: #727272;
      font-size: 0.75em;
      font-weight: 500;
      font-family: "Roboto", sans-serif;
    }
  }
}
</style>
    